import { SHIPPING_METHOD_TYPE } from '@/modules/perseo-billing/constants/src';
import type {
  THomeDeliveryOrderConfirmation,
  TIntangibleDeliveryWithoutEmail,
  TNoviosDeliveryWithoutEmail,
  TPickupDelivery
} from '@/modules/perseo-billing/interfaces/src/bff-web/billing/interfaces/summary.interface';

export const isHomeDeliveryOrderConfirmation = (
  delivery: unknown
): delivery is THomeDeliveryOrderConfirmation => {
  if (!delivery || typeof delivery !== 'object') {
    return false;
  }

  const deliveryObj = delivery as Record<string, unknown>;

  return (
    deliveryObj.shippingMethodType === SHIPPING_METHOD_TYPE.HOME_DELIVERY &&
    typeof deliveryObj.streetName === 'string' &&
    typeof deliveryObj.streetNumber === 'string' &&
    typeof deliveryObj.region === 'string' &&
    typeof deliveryObj.commune === 'string'
  );
};

export const isPickupDelivery = (
  delivery: unknown
): delivery is TPickupDelivery => {
  if (!delivery || typeof delivery !== 'object') {
    return false;
  }

  const deliveryObj = delivery as Record<string, unknown>;

  return (
    deliveryObj.shippingMethodType === SHIPPING_METHOD_TYPE.PICK_UP &&
    typeof deliveryObj.pickupStoreName === 'string' &&
    typeof deliveryObj.recipientFullName === 'string'
  );
};

export const isIntangibleDeliveryWithoutEmail = (
  delivery: unknown
): delivery is TIntangibleDeliveryWithoutEmail => {
  if (!delivery || typeof delivery !== 'object') {
    return false;
  }

  const deliveryObj = delivery as Record<string, unknown>;

  return deliveryObj.shippingMethodType === SHIPPING_METHOD_TYPE.INTANGIBLE;
};

export const isNoviosDeliveryWithoutEmail = (
  delivery: unknown
): delivery is TNoviosDeliveryWithoutEmail => {
  if (!delivery || typeof delivery !== 'object') {
    return false;
  }

  const deliveryObj = delivery as Record<string, unknown>;

  return deliveryObj.shippingMethodType === SHIPPING_METHOD_TYPE.NOVIOS;
};
